import type { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost';

const variants: Record<Variant, string> = {
  primary: 'bg-accent-strong text-white hover:bg-accent disabled:bg-accent-strong/50',
  secondary:
    'border border-line-strong bg-surface-raised text-fg hover:bg-surface-hover disabled:text-fg-subtle',
  ghost: 'text-fg-muted hover:bg-surface-hover hover:text-fg disabled:text-fg-subtle',
};

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

export function Button({ variant = 'secondary', className = '', type = 'button', ...rest }: Props) {
  return (
    <button
      type={type}
      className={`inline-flex h-8 items-center gap-2 rounded-md px-3 text-[13px] font-medium transition-colors disabled:cursor-not-allowed ${variants[variant]} ${className}`}
      {...rest}
    />
  );
}
